"use strict";
// Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
var DragType;
(function (DragType) {
    DragType[DragType["BEGIN"] = 0] = "BEGIN";
    DragType[DragType["DRAG"] = 1] = "DRAG";
    DragType[DragType["END"] = 2] = "END";
})(DragType || (DragType = {}));
exports.default = DragType;
//# sourceMappingURL=DragType.js.map